module.exports = __webpack_public_path__ + "img/tool_background_black.f3cdf406.png";